import type { TableDataType } from "./types";

/**
 * Returns true if string contains only digits (presence of decimal point returns false)
 * @param {string} value
 * @returns boolean
 */
export function isNum(value: string): boolean {
  return /^\d+$/.test(value);
}

/**
 * Turns values into numbers - returns 0 if figure invalid
 * @param entry
 * @returns number
 */
export function processNumericEntry(
  entry: string | number | null | undefined
): number {
  if (typeof entry === "number") return entry;
  if (typeof entry === "string" && isNum(entry)) {
    return Number(entry);
  }
  return 0;
}

export function sortBy(
  fieldName: string,
  data: TableDataType[] | undefined,
  isAscending: boolean
) {
  if (!data) return [];
  return data.sort((a: TableDataType, b: TableDataType) => {
    const processEntry = (entry) => {
      // Sort custom data types
      // Sorts primarily by country, rather than by city
      if (fieldName === "location")
        return `${entry.location[1]}, ${entry.location[0]}`;

      // For rank, we want to handle it as a number
      if (fieldName === "rank") return Number(entry[fieldName]) || 0;

      if (typeof entry[fieldName] === "string")
        return String(entry[fieldName]).toLowerCase();
      return entry[fieldName];
    };

    const first = processEntry(a);
    const second = processEntry(b);
    if (first === "" || first === null || first === 0) return 1;
    if (second === "" || second === null || second === 0) return -1;
    if (first === second) return 0;

    if (isAscending) {
      return first > second ? 1 : -1;
    } else {
      return first < second ? 1 : -1;
    }
  });
}

export function formatMoney(
  value: string | number
): [number, string] | undefined {
  const n = Number(value);
  if (n < 1e3) return [n, ""];
  if (n >= 1e3 && n < 1e6) return [+(n / 1e3).toFixed(0), "k"];
  if (n >= 1e6 && n < 1e9) return [+(n / 1e6).toFixed(1), "m"];
  if (n >= 1e9 && n < 1e12) return [+(n / 1e9).toFixed(1), "b"];
  if (n >= 1e12) return [+(n / 1e12).toFixed(1), "t"];
  return undefined;
}
